// AppAccessBanner.jsx

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../auth/authContext';
import AVIcon from '../icons/AllVoicedIcons';
import SignUpModal from '../modals/web-modals/SignUpModal';
import LoginModal from '../modals/web-modals/LoginModal';

const AppAccessBanner = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const [isSignUpOpen, setSignUpOpen] = useState(false);
  const [isLoginOpen, setLoginOpen] = useState(false);

  if (user) return null;

  return (
    <section className="access-banner">
      <div className="access-banner__content">
        <div className="access-banner__icon" aria-hidden="true">
          <AVIcon icon="isotypePositive" size={36} color="#209385" />
        </div>

        <h2 className="access-banner__title">
          {t('access_app_title', 'Start listening with All-Voiced')}
        </h2>

        <p className="access-banner__subtitle">
          {t(
            'access_app_description',
            'Access structured listening tasks, perceptual voice training, and feedback tools.'
          )}
        </p>

        <div className="access-banner__actions web-cta-row">
          <button
            type="button"
            className="web-button web-button--primary"
            onClick={() => setSignUpOpen(true)}
          >
            {t('sign_up_for_free', 'Create a free account')}
          </button>

          <button
            type="button"
            className="web-button web-button--secondary"
            onClick={() => setLoginOpen(true)}
          >
            {t('login', 'Log in')}
          </button>
        </div>

        <SignUpModal
          isOpen={isSignUpOpen}
          onRequestClose={() => setSignUpOpen(false)}
          openLoginModal={() => {
            setSignUpOpen(false);
            setLoginOpen(true);
          }}
        />

        <LoginModal
          isOpen={isLoginOpen}
          onRequestClose={() => setLoginOpen(false)}
          openSignUpModal={() => {
            setLoginOpen(false);
            setSignUpOpen(true);
          }}
        />
      </div>
    </section>
  );
};

export default AppAccessBanner;
